const game = {
  init(stage, screens, config, lib) {
    this.currentScreen = null;
    this.stage = stage;
    this.screens = screens;
    this.lib = lib;
    this.config = config;

    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();

    this.changeScreen('Main');
    this.currentScreen.addEventListener('play-double', () => this.eventDispatcher.dispatchEvent('play-double'));
  },

  addEventListener(evt, fn) {
    this.eventDispatcher = this.eventDispatcher || new createjs.EventDispatcher();
    this.eventDispatcher.addEventListener(evt, fn);
  },

  play(res, winSymbols) {
    return this.currentScreen.play(res, winSymbols);
  },

  stop() {
    return this.currentScreen.stop();
  },

  showFreeSpinsLeft(freeSpins, freeSpinsDone) {
    return this.currentScreen.showFreeSpinsLeft(freeSpins, freeSpinsDone);
  },

  showLines(lines) {
    this.currentScreen.showLines(lines);
  },

  playDouble(win, step) {
    return this.currentScreen.playDouble(win, step);
  },

  showDouble(step) {
    return this.currentScreen.showDouble(step);
  },

  changeScreen(screen) {
    if (this.currentScreen && this.currentScreen.view) {
      this.stage.removeChild(this.currentScreen.view);
    }

    this.currentScreen = new this.screens[screen](this.config, this.lib);
    this.stage.addChild(this.currentScreen.view);
  },

  tick(e) {
    if (this.currentScreen && this.currentScreen.tick) {
      this.currentScreen.tick(e);
    }
  },
};

export default game;



// WEBPACK FOOTER //
// ../base/js/game.js